function BussinessNumber() {
  return <div>Bussiness Number</div>;
}

export default BussinessNumber;
